import { render, staticRenderFns } from "./AmazeLike.vue?vue&type=template&id=1a09f245&scoped=true"
import script from "./AmazeLike.vue?vue&type=script&lang=js"
export * from "./AmazeLike.vue?vue&type=script&lang=js"
import style0 from "./AmazeLike.vue?vue&type=style&index=0&id=1a09f245&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a09f245",
  null
  
)

export default component.exports